import lazyLoader from '../common/lazy-load';

window.lazyLoader = lazyLoader;